import React from 'react';
import { FileDown } from 'lucide-react';

const BASE_CLASS =
  'flex h-full min-h-[6.5rem] flex-col items-center justify-center gap-2.5 rounded-2xl px-4 py-5 text-center text-sm font-semibold leading-snug shadow-xs transition-all group';

const VARIANT_CLASSES = {
  blue: 'border border-indigo-200 bg-indigo-50/60 text-indigo-900 hover:bg-indigo-100 hover:border-indigo-300',
  red: 'border border-slate-300 bg-slate-100 text-slate-800 hover:bg-slate-200 hover:border-slate-400',
  neutral:
    'border border-slate-600/30 bg-slate-800 text-white hover:bg-slate-700 hover:border-slate-500/50'
};

const ICON_CLASSES = {
  blue: 'text-indigo-500',
  red: 'text-slate-500',
  neutral: 'text-slate-300'
};

export default function DocumentoDownloadCard({ href, label, variant = 'blue' }) {
  return (
    <a href={href} download className={`${BASE_CLASS} ${VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.blue}`}>
      <FileDown
        className={`h-5 w-5 shrink-0 transition-transform group-hover:-translate-y-0.5 ${ICON_CLASSES[variant] ?? ICON_CLASSES.blue}`}
      />
      <span>{label}</span>
    </a>
  );
}
